import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Introduction from './visualizers/Introduction';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import LinearSearch from './visualizers/search/LinearSearch';
import BinarySearch from './visualizers/search/BinarySearch';
import CompareSearches from './visualizers/search/CompareSearches';
import SortPage from './pages/SortPage';
import QuickSort from './visualizers/sorting/QuickSort';
import BubbleSort from './visualizers/sorting/BubbleSort';
import MergeSort from './visualizers/sorting/MergeSort';
import CompareSorts from './visualizers/sorting/CompareSorts';
import ListsPage from './pages/ListsPage';
import StackVisualizer from './visualizers/lists/listwrapper/StackWrapper';
import QueueVisualizer from './visualizers/lists/listwrapper/QueueWrapper'; 
import LinkedListVisualizer from './visualizers/lists/listwrapper/LinkedListWrapper';
import DoublyLinkedListVisualizer from './visualizers/lists/listwrapper/DoublyLinkedListWrapper';
import RingBufferVisualizer from './visualizers/lists/listwrapper/RingBufferWrapper'; 
import CompareLists from './visualizers/lists/listwrapper/CompareList';
import RecursionPage from './pages/RecursionPage';
import FactorialWrapper  from './visualizers/recursion/recursionwrappers/FactorialWrapper';
import FibonacciWrapper from './visualizers/recursion/recursionwrappers/FibonacciWrapper';
import PalindromeWrapper from './visualizers/recursion/recursionwrappers/PalindromeWrapper';
import CompareRecursionPage from './visualizers/recursion/recursionwrappers/CompareRecursion';
import TreesPage from './pages/TreesPage';
import BinaryTreeWrapper from './visualizers/trees/TreeWrapper/BinaryTreeWrapper';
import BSTWrapper from 'visualizers/trees/TreeWrapper/BSTWrapper';
import CompareTreeWrapper from 'visualizers/trees/TreeWrapper/CompareTrees';
import AdvanceTreesPage from 'pages/AdvanceTreesPage';
import MinHeapWrapper from 'visualizers/advancetrees/AdvanceTreesWrapper/MinHeapWrapper';
import MaxHeapWrapper from 'visualizers/advancetrees/AdvanceTreesWrapper/MaxHeapWrapper';
import TrieWrapper from 'visualizers/advancetrees/AdvanceTreesWrapper/TrieWrapper';
import CompareAdvancedTrees from 'visualizers/advancetrees/AdvanceTreesWrapper/CompareAdvancedTrees';
import GraphPage from 'pages/GraphsPage';
import UndirectedGraphWrapper from 'visualizers/graph/GraphWrapper/UndirectedGraphWrapper';
import DirectedGraphWrapper from 'visualizers/graph/GraphWrapper/DirectedGraphWrapper';
import DijkstraWrapper from 'visualizers/graph/GraphWrapper/DijkstraWrapper';
import CompareGraphsWrapper from 'visualizers/graph/GraphWrapper/CompareGraphsWrapper';
import MapsPage from 'pages/MapsPage';
import HashMapWrapper from 'visualizers/maps/mapwrapper/HashMapWrapper';
import LruWrapper from 'visualizers/maps/mapwrapper/LruWrapper';
import LfuWrapper from 'visualizers/maps/mapwrapper/LfuWrapper';
import CompareCache from 'visualizers/maps/mapwrapper/CompareCache';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/intro" element={<Introduction />} />
          <Route path="/search/linear" element={<LinearSearch />} />
          <Route path="/search/binary" element={<BinarySearch />} />
          <Route path="/search/compare" element={<CompareSearches />} />
          <Route path="/sort" element={<SortPage />} />
          <Route path="/sort/quick" element={<QuickSort />} />
          <Route path="/sort/bubble" element={<BubbleSort />} />
          <Route path="/sort/merge" element={<MergeSort />} /> 
          <Route path="/sort/compare" element={<CompareSorts />} />
          <Route path="/lists" element={<ListsPage />} />
          <Route path="/lists/stack" element={<StackVisualizer />} />
          <Route path="/lists/queue" element={<QueueVisualizer />} />
          <Route path="/lists/linked-list" element={<LinkedListVisualizer />} />
          <Route path="/lists/doubly-linked-list" element={<DoublyLinkedListVisualizer />} />
          <Route path="/lists/ring-buffer" element={<RingBufferVisualizer />} /> 
          <Route path="/lists/comparelist" element={<CompareLists />} />
          <Route path="/recursion" element={<RecursionPage />} />
          <Route path="/recursion/factorial" element={<FactorialWrapper />} />
          <Route path="/recursion/fibonacci" element={<FibonacciWrapper  />} />
          <Route path="/recursion/palindrome" element={<PalindromeWrapper  />} />
          <Route path="/recursion/comparerecursion" element={<CompareRecursionPage />} />
          <Route path="/trees" element={<TreesPage />} />
          <Route path="/trees/binarytrees" element={<BinaryTreeWrapper />} />
          <Route path="/trees/binarysearchtrees" element={<BSTWrapper />} />
          <Route path="/trees/comparetrees" element={<CompareTreeWrapper />} />
          <Route path="/advancetrees/" element={<AdvanceTreesPage />} />
          <Route path="/advancetrees/minheap" element={<MinHeapWrapper />} />
          <Route path="/advancetrees/maxheap" element={<MaxHeapWrapper />} />
          <Route path="/advancetrees/tries" element={<TrieWrapper />} />
          <Route path="/advancetrees/compareadvancetrees" element={<CompareAdvancedTrees />} />
          <Route path="/graph" element={<GraphPage />} />
          <Route path="/graph/undirected" element={<UndirectedGraphWrapper />} />
          <Route path="/graph/directed" element={<DirectedGraphWrapper />} />
          <Route path="/graph/dijkstra" element={<DijkstraWrapper />} />
          <Route path="/graph/comparegraphs" element={<CompareGraphsWrapper />} />
          <Route path="/map" element={<MapsPage />} />
          <Route path="/map/hashmap" element={<HashMapWrapper />} />
          <Route path="/map/lru" element={<LruWrapper />} />
          <Route path="/map/lfu" element={<LfuWrapper />} />
          <Route path="/map/comparecache" element={<CompareCache />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;